import type { ReactNode } from 'react';
import type { ActivityType } from '../../types';
import {
  MapPin, Utensils, Coffee, Landmark, Eye, Building2, TreePine,
  ShoppingBag, Sparkles, Bus, Hotel as HotelIcon, SquareParking, Waves, Mountain,
} from '../../components/ui/Icon';

/** Bits every tab of the public share page shares. Kept out of the page shell
 *  so no single file grows past the JSX budget in CLAUDE.md. */

export const TYPE_ICON: Record<ActivityType, React.ElementType> = {
  RESTAURANT: Utensils, CAFE: Coffee, MONUMENT: Landmark, VIEWPOINT: Eye,
  NEIGHBORHOOD: Building2, PARK: TreePine, SHOP: ShoppingBag,
  EXPERIENCE: Sparkles, TRANSPORT: Bus, PARKING: SquareParking, BEACH: Waves, NATURE: Mountain, ACCOMMODATION: HotelIcon, OTHER: MapPin,
};

export const TYPE_COLOR: Record<ActivityType, string> = {
  RESTAURANT: 'text-orange-500', CAFE: 'text-amber-600', MONUMENT: 'text-violet-500',
  VIEWPOINT: 'text-sky-500', NEIGHBORHOOD: 'text-indigo-500', PARK: 'text-green-500',
  SHOP: 'text-pink-500', EXPERIENCE: 'text-teal-500', TRANSPORT: 'text-slate-500',
  PARKING: 'text-blue-600', BEACH: 'text-cyan-500', NATURE: 'text-lime-600', ACCOMMODATION: 'text-blue-500', OTHER: 'text-slate-400',
};

const DEST_COLORS: [string, string][] = [
  ['paris', '#f43f5e'], ['london', '#475569'], ['new york', '#f59e0b'],
  ['lisboa', '#0d9488'], ['lisbon', '#0d9488'], ['madrid', '#ef4444'],
  ['barcelona', '#f97316'], ['rome', '#d97706'], ['tokyo', '#ec4899'],
  ['dubai', '#eab308'], ['amsterdam', '#0ea5e9'],
];

export function getDestColor(dest: string): string {
  const lower = dest.toLowerCase();
  return DEST_COLORS.find(([k]) => lower.includes(k))?.[1] ?? '#0d9488';
}

export function EmptyNote({ children }: { children: ReactNode }) {
  return <p className="text-sm text-slate-400 italic py-6 text-center">{children}</p>;
}

/** A stop's or a place's free text. Only ever rendered when NOTES is shared. */
export function SharedNote({ text }: { text?: string | null }) {
  if (!text) return null;
  return (
    <p className="text-xs text-slate-500 dark:text-slate-400 mt-1 leading-relaxed whitespace-pre-wrap break-words">
      {text}
    </p>
  );
}
